import { styled } from 'styled-components'

import { Title } from 'assets/styles/common.style'
import { DEVICE_SIZE } from 'utils/constants'

export const Container = styled.div`
  background-color: var(--white);
  height: 100%;
  width: 100%;
`

export const Wrapper = styled.section`
  margin: 0 auto;
  width: 618px;
  @media (max-width: ${DEVICE_SIZE.MOBILE_L}) {
    width: 90%;
  }
`

export const NewTitle = styled(Title)`
  padding-top: 70px;
  text-align: center;
`

export const SubTitle = styled.h3`
  text-align: center;
`

export const Form = styled.form`
  margin: 0 auto;
  width: 400px;
  @media (max-width: ${DEVICE_SIZE.MOBILE_L}) {
    width: 100%;
  }
`

export const Message = styled.p`
  color: ${({ isValid }) =>
    isValid ? 'var(--green-border)' : 'var(--red-message)'};
  font-family: var(--fontRegular);
  font-size: 14px;
  text-align: left;
`

export const BoxButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
  @media (max-width: ${DEVICE_SIZE.MOBILE_L}) {
    flex-direction: column;
  }
`
